<template>
    <div>
        <el-dialog v-dialogDrag :visible.sync="openCollect" class="collect-dialog">
            <div slot="title" class="dialog-header">
                <img class="collect-icon" src="@/assets/images/bookIcons/collect3.png" alt="">
                <div class="collect-title">收藏夹</div>
                <div class="line-area"></div>
            </div>
            <el-checkbox-group v-model="checkList" max="1" class="dialog-content">
                <el-checkbox v-for="item in collections" :label="item.name" :key="item.id" class="checkbox" @change="checkClick(item)">
                {{ item.name }}
                    <div class="checkbox-num">{{ item.num }}本</div>
                </el-checkbox>
            </el-checkbox-group>

            <span slot="footer" class="dialog-footer">
                <el-input v-model="newCollect" placeholder="新建收藏夹" class="collect-input"
                    @keyup.enter.native="addCollect()">
      <i slot="suffix" class="el-input__icon el-icon-plus" @click="addCollect()"><span >新增收藏夹</span></i>
                </el-input>

                <button class="confirm" @click="collectBook()">确 定</button>
                <button class="cancel" @click="openCollect = false">取 消</button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { Message } from 'element-ui'
export default {
  name: 'RetrieveDialogCollect',
  props: {
    openCollect: {
      type: Boolean,
      required: true
    },
    bookId: {
      type: String,
      required: true
    },
    isCollected: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      collections: [],
      newCollect: '',
      // eslint-disable-next-line vue/no-dupe-keys
      openCollect: false,
      checkList: [],
      collectId: 0
    }
  },
  created () {
    this.getCollect()
  },
  watch: {
    openCollect () {
      this.$emit('closeCollect', false)
    }
  },
  methods: {
    getCollect () {
      this.collections = []
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/store/getAllStores?userId=' + userId
      this.$http.get(url).then(res => {
        for (let i in res.data.data) {
          let tmp = res.data.data[i]
          let col = {
            name: tmp.store.storeName,
            id: tmp.store.id,
            num: tmp.bookTotalCount
          }
          this.collections.push(col)
        }
      })
        .catch(err => {
          console.log('获取收藏夹失败', err)
        })
    },
    addCollect () {
      // console.log('添加收藏夹：', this.newCollect)
      if (this.newCollect !== '' && this.newCollect.split(" ").join("").length === this.newCollect.length) {
        console.log(this.newCollect)
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/store/addStore?userId=' + userId + '&storeName=' + this.newCollect
        this.$http.post(url).then(res => {
          this.newCollect = ''
          Message({
            type: 'success',
            message: '添加收藏夹成功!'
          })
          this.$emit('success', true)
          this.getCollect()
        })
          .catch(err => {
            // console.log('新增收藏夹失败', err)
            Message({
              type: 'error',
              message: '添加收藏夹失败!'
            })
          })
      } else {
        Message({
          type: 'error',
          message: '收藏夹名称不能为空或含有空格!'
        })
      }
    },
    checkClick (item) {
      if (item.id === this.collectId) {
        this.collectId = 0
      } else {
        this.collectId = item.id
      }
      console.log(this.collectId)
    },
    collectBook () {
      this.openCollect = false
      if (this.collections.length === 0) {
        Message({
          type: 'error',
          message: '收藏失败，请先创建一个收藏夹!'
        })
      } else if (this.collectId > 0) {
        console.log('有收藏夹')
        let url = 'retrieve/storeBook/addBookInStore?storeId=' + this.collectId + '&bookId=' + this.bookId
        this.$http.post(url).then(res => {
          this.$bus.$emit('collectSuccess', this.bookId)
          Message({
            type: 'success',
            message: res.data.message,
          })
          this.getCollect()
        }, err => {
          // console.log(err)
          Message({
            type: 'error',
            message: '收藏失败!'
          })
        })
      } else if (this.collectId === 0) {
        Message({
          type: 'error',
          message: '收藏失败，请先选择一个收藏夹！'
        })
      }
    }
  }
}
</script>

<style scoped>
/* 收藏弹窗 */
.collect-icon {
    width: 16.19px;
    height: 15.79px;
}

.collect-dialog>>>.el-dialog {
    height: 315px;
    width: 383px !important;
    margin-top: 35vh !important;
    text-align: left;
}
.collect-dialog >>> .el-dialog__headerbtn {
    top: 5px !important;
    right: 4px;
    background: url('../assets/images/bookIcons/close.png') left no-repeat;
    background-size: cover;
    font-family:"Avenir", Helvetica, Arial, sans-serif;
    width:20px;
    height: 20px;
}
.collect-dialog ::-webkit-scrollbar {
  background-color: #e8e9f5;
  width: 4px;
}

.collect-dialog ::-webkit-scrollbar-thumb {
  background-color: #9e5c1d;
}
.collect-dialog>>>.el-dialog__header {
    padding: 17px 0 0 19px;
}

.collect-dialog>>>.el-dialog__body {
    padding-top: 20px;
}

.collect-title {
    font-size: 18px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #9E5C1D;
    display: inline;
    margin:0 0 15px 14px;
    bottom: 15px;
}

.line-area {
    width: 115px;
    margin-top: 12px;
    border-bottom: 1px solid #9E5C1D;
}

.checkbox {
    display: block;
    line-height: 36px !important;
    font-size: 16px !important;
    margin-right: 0;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
}

.dialog-content{
  height: 130px;
  overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}
.checkbox>>>.el-checkbox {
    margin-right: 0;
}

.checkbox>>>.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #9E5C1D;
}

.checkbox>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9E5C1D;
    border-color: #9E5C1D;
}

.checkbox>>>.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #9E5C1D;
}

.checkbox-num {
    display: inline;
    position: absolute;
    right: 0;
}

.collect-dialog>>>.el-dialog__footer {
    position: absolute;
    bottom: 15px;
    width: 383px;
    text-align: center;
    padding: 0;
}

.collect-input {
    width: 70%;
    display: block;
    margin: 0 auto;
    bottom: 20px;
}

.collect-input>>>.el-input__inner {
    color: #9E5C1D;
    border: 1px solid #9E5C1D;
}

.collect-input>>>.el-input__prefix,
.el-input__suffix {
    color: #9E5C1D;
}
.el-input__icon {
    cursor: pointer;
    position: relative;
}
.el-input__icon span{
    display: none;
}
.el-input__icon:hover span{
    display: block;
    position:absolute;
    top: -35px;
    left: -35px;
    width: 100px;
    border: 1px solid #9E5C1D;
    color: #9E5C1D;
    text-align: center;
    background-color: #f5eee8;
}
.confirm {
    width: 90px;
    height: 35px;
    background: #9E5C1D;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 0;
    padding: 0;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
}

.cancel {
    width: 90px;
    height: 35px;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    border: 1px solid #9E5C1D;
    padding: 0 0 0 0;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
    cursor: pointer;
    margin-left: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveDialogCollect.vue